import { render, staticRenderFns } from "./PortForwardList.vue?vue&type=template&id=9b19fcda&"
import script from "./PortForwardList.vue?vue&type=script&lang=js&"
export * from "./PortForwardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports